import { css } from 'aphrodite';
import { useState } from 'react';
import { Input } from '../../components-v2/Input';
import { MAX_FONT_SIZE, MIN_FONT_SIZE } from './constants';
import { styleSheet } from './styles';

interface FontSizeInputProps {
	label: string;
	value?: number;
	onChange: (fontSize: number) => void;
}

export const FontSizeInput = ({ label, value, onChange }: FontSizeInputProps) => {
	const [draft, setDraft] = useState<string | null>(null);

	const commit = () => {
		const typed = Number(draft);
		if (draft !== null && draft !== '' && Number.isFinite(typed)) {
			onChange(Math.min(Math.max(Math.round(typed), MIN_FONT_SIZE), MAX_FONT_SIZE));
		}
		setDraft(null);
	};

	return (
		<div className={css(styleSheet.formGroup, styleSheet.fieldRowFontSize)}>
			<label className={css(styleSheet.label)}>{label}</label>
			<Input
				type='number'
				min={MIN_FONT_SIZE}
				max={MAX_FONT_SIZE}
				value={draft ?? value ?? ''}
				disabled={value == null}
				placeholder={value == null ? 'Sized by its box' : undefined}
				onChange={event => setDraft(event.target.value)}
				onBlur={commit}
				onKeyDown={event => {
					if (event.key === 'Enter') {
						commit();
					}
				}}
			/>
		</div>
	);
};
